module.exports = __webpack_public_path__ + "static/photogrammetry-7a4a07954e2ff4818e72a993fb801170.jpg";